<template>
  <div class="m-acv-wrapper">
    <div class="m-acv-wrapper-item">
      <div class="m-acv-wrapper-item-title">
        <WaveTitle title="公司年报" subhead="Company annual report" isMobile />
      </div>
      <div class="m-acv-wrapper-item-content">
        <div class="card-box">
          <div class="card-box-item" v-for="annual in annualList" :key="annual.id">
            <a :href="annual && annual.reportUrl" target="_blank" r>
              <div class="top">
                <div class="year">
                  <span>{{ extractYearAndTypeFromText(annual && annual.title).year }}</span>
                  <span>年</span>
                </div>
                <div class="type">{{ extractYearAndTypeFromText(annual && annual.title).type }}</div>
                <div class="text-en">Annual Report</div>
              </div>
              <div class="bottom">上海艾融软件股份有限公司</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="m-acv-wrapper-item">
      <div class="m-acv-wrapper-item-title">
        <WaveTitle title="公司中报" subhead="Company interim report" isMobile />
      </div>
      <div class="m-acv-wrapper-item-content">
        <div class="card-box">
          <div class="card-box-item" v-for="inter in InterimList" :key="inter.id">
            <a :href="inter && inter.reportUrl" target="_blank" r>
              <div class="top">
                <div class="year">
                  <span>{{ extractYearAndTypeFromText(inter && inter.title).year }}</span>
                  <span>年</span>
                </div>
                <div class="type">{{ extractYearAndTypeFromText(inter && inter.title).type }}</div>
                <div class="text-en">Interim Report</div>
              </div>
              <div class="bottom">上海艾融软件股份有限公司</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="m-acv-wrapper-item">
      <div class="m-acv-wrapper-item-title">
        <WaveTitle title="公司季报" subhead="Company quarterly report" isMobile />
      </div>
      <div class="m-acv-wrapper-item-content">
        <div class="card-box">
          <div class="card-box-item" v-for="quart in QuarterlyList" :key="quart.id">
            <a :href="quart && quart.reportUrl" target="_blank" r>
              <div class="top">
                <div class="year">
                  <span>{{ extractYearAndTypeFromText(quart && quart.title).year }}</span>
                  <span>年</span>
                </div>
                <div class="type">{{ extractYearAndTypeFromText(quart && quart.title).type }}</div>
                <div class="text-en">Quarterly Report</div>
              </div>
              <div class="bottom">上海艾融软件股份有限公司</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WaveTitle from "@/components/WaveTitle.vue";
  import { useGetAchieventListApi } from "@/api/useAchieventApi";

  export default {
    name: "AchievementComp",
    components: { WaveTitle },
    props: {},
    data() {
      return {
        // 年报
        annualList: [],
        // 中报
        InterimList: [],
        // 季报
        QuarterlyList: [],
        datas: [],
        query_type: "",
        page: {
          totle: "",
          currentPage: 2,
          pageSize: 8,
        },
        staic: "",
        // 业绩报告年份范围
        reportYearRange: "2019-" + new Date().getFullYear(),
      };
    },
    filters: {},
    created() {
      this.getachievent();
      this.query_type = this.$route.query.category;
      console.log("this.query_type", this.query_type);
      window.scrollTo(0, 540);
    },
    mounted() {
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    methods: {
      // 获取业绩表
      async getachievent() {
        try {
          // 年报业报
          const annualRes = await useGetAchieventListApi({
            pageNum: 1,
            pageSize: 100,
            reportType: "year",
          });
          this.annualList = annualRes.records || [];

          // 中报业报
          const interimRes = await useGetAchieventListApi({
            pageNum: 1,
            pageSize: 100,
            reportType: "half",
          });
          this.InterimList = interimRes.records || [];

          // 季报业报
          const quarterlyRes = await useGetAchieventListApi({
            pageNum: 1,
            pageSize: 100,
            reportType: "quarter",
          });
          this.QuarterlyList = quarterlyRes.records || [];
        } catch (error) {
          console.error("获取业绩报告失败:", error);
        }
      },
      /**
       * 从文件名中提取年份和年份后的文字内容
       * @param {string} text - 文件名文本，如"上海艾融软件股份有限公司2024年半年报告.pdf"
       * @returns {Object} 包含年份和类型的对象
       */
      extractYearAndTypeFromText(text) {
        // 确保传入的是字符串
        if (typeof text !== "string" || !text) {
          return { year: "", type: "" };
        }
        // 提取年份（4位数字）
        const yearMatch = text.match(/(\d{4})年/);
        const year = yearMatch ? yearMatch[1] : "";
        // 提取年份后的文字内容（年份后直到字符串结尾的所有内容）
        const typeMatch = text.match(/\d{4}年(.+)/);
        const type = typeMatch ? typeMatch[1] : "";
        return {
          year: year,
          type: type,
        };
      },
      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .m-acv-wrapper {
    padding: 0px 10px;
    padding-bottom: 22px;
    .m-acv-wrapper-item {
      .m-acv-wrapper-item-title {
        padding: 27px 0px;
      }
      .m-acv-wrapper-item-content {
        .card-box {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 10px;

          .card-box-item {
            width: 100%;
            padding: 14px 20px;
            background: #ffffff;
            box-sizing: border-box;
            border: 0.5px solid rgba(0, 0, 0, 0.1);
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);

            .top {
              display: flex;
              flex-direction: column;
              row-gap: 4px;
              padding: 20px;
              font-weight: normal;
              line-height: normal;
              text-align: center;
              letter-spacing: 0em;
              color: #001f34;
              .year {
                font-size: 24px;
                font-weight: 700;
                span:last-child {
                  font-weight: 400;
                }
              }
              .type {
                font-size: 18px;
                font-weight: 400;
              }
              .text-en {
                font-size: 12px;
                color: #f49a42;
              }
            }
            .bottom {
              font-size: 11px;
              font-weight: 250;
              color: #001f34;
            }
          }

          .card-box-item:hover {
            background: #f49a42;
            .top {
              color: #fff;
            }
            .bottom {
              color: #fff;
            }
            .text-en {
              color: #fff;
            }
          }
          .card-box-item:active {
            background: #f49a42;
            .top {
              color: #fff;
            }
            .bottom {
              color: #fff;
            }
            .text-en {
              color: #fff;
            }
          }
        }
      }
    }
  }
</style>
